import * as ScrollMagic from "scrollmagic";
import { TweenMax, TimelineMax } from "gsap";
import { ScrollMagicPluginGsap } from "scrollmagic-plugins";
import { ScrollMagicPluginIndicator } from "scrollmagic-plugins";
import { gsap } from "gsap";
//import { splitColor } from 'gsap/all';

ScrollMagicPluginIndicator(ScrollMagic);
ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

var $ = jQuery;
var $window = $(window);
var previousScrollTop = 0;
var scrollLock = false;
//let copyLink = copyLink;
//let copied = copied;

gsap.config({
  nullTargetWarn: false,
});

// menu
function menuPwFullscreen() {
  let menutl = new TimelineMax({ paused: false, reversed: true, delay: 0.5 });
  let ma = $(".menu-item a");
  let mmp = $(".mask-menu");
  let cm = $(".contacts-menu");
  let menufullscreen = document.querySelector(".wpbf-menu-full-screen");

  menutl.staggerFromTo(
    ma,
    0.1,
    { y: "-1vh", opacity: 0 },
    { y: 0, opacity: 1 },
    0.1
  );
  menutl.fromTo(mmp, 0.5, { x: "100%", opacity: 0 }, { x: 0, opacity: 1 });
  menutl.fromTo(cm, 0.5, { x: "-2vh", opacity: 0 }, { x: 0, opacity: 1 });

  let menuopen = false;
  console.log(menuopen);

  function toggleMenu() {
    menufullscreen.style.display = "block";
    $("body").toggleClass("stop-scrolling", !menuopen);
    if (menuopen) {
      menutl.timeScale(1.5).reverse();
      menufullscreen.style.display = "none"; // Hide the menu
    } else {
      menufullscreen.style.display = "block"; // Show the menu
      menutl.play();
    }
    menuopen = !menuopen;
  }

  $(".wpbf-menu-toggle-pw").click(toggleMenu);

  // Hide menu when clicking on any anchor link inside the menu
  $(".menu-item a").click(function () {
    if (menuopen) {
      toggleMenu();
    }
  });
}

(function ($) {
  $(document).ready(function () {
    menuPwFullscreen();
    let ScreenWidth = $(window).width(),
      ScreenHeight = $(window).height(),
      headerHeight = $(".header").outerHeight();

    // SCROLLMAGIC SCENE
    // let controller = new ScrollMagic.Controller({
    //   loglevel: 0,
    // });

    var controller = new ScrollMagic.Controller({
      globalSceneOptions: {
        overwrite: "auto",
      },
    });

    //_____________________________________________________________

    $(".elementor-section:not(.hero)").each(function (index, elem) {
      // Create Animations
      let lead = $(elem).find(".headline.lead"),
        headline = $(elem).find(".headline.vetrina"),
        headlineintro = $(elem).find(".headline.intro"),
        text = $(elem).find(".testo"),
        textintro = $(elem).find(".testo.intro"),
        elementorWidgetImage = $(elem).find(".elementor-widget-image"),
        shortcode = $(elem).find(".elementor-widget-shortcode"),
        slickarrow = $(elem).find(".slick-arrow"),
        elbutton = $(elem).find(".elementor-widget-button"),
        heroheadline = $(elem).find(".headline.t1");

      let tl = new TimelineMax();
      tl.fromTo(
        lead,
        0.5,
        { y: "2.5vh", opacity: 0 },
        { y: 0, opacity: 1 },
        "start"
      )

        .fromTo(
          headline,
          0.5,
          { y: "-2.5vh", opacity: 0 },
          { y: 0, opacity: 1 },
          "start"
        )
        .fromTo(
          text,
          0.5,
          { y: "-2.5vh", opacity: 0 },
          { y: 0, opacity: 1 },
          "start"
        )
        .fromTo(
          shortcode,
          0.5,
          { y: "-2.5vh", opacity: 0 },
          { y: 0, opacity: 1 },
          "start"
        )
        .fromTo(
          heroheadline,
          0.5,
          { y: "-2.5vh", opacity: 0 },
          { y: 0, opacity: 1 },
          "start"
        )
        .fromTo(
          elementorWidgetImage,
          0.5,
          { opacity: 0 },
          { opacity: 1, stagger: 0.5 },
          "start"
        )
        .fromTo(
          headlineintro,
          0.5,
          { y: "-2.5vh", opacity: 0 },
          { y: 0, opacity: 1 },
          "start"
        )
        .fromTo(
          textintro,
          1,
          { y: "-2.5vh", opacity: 0 },
          { y: 0, opacity: 1 },
          "start"
        )
        .fromTo(
          elbutton,
          1.5,
          { x: "-2.5vh", opacity: 0 },
          { x: "0", opacity: 1 },
          "start"
        )
        .fromTo(
          slickarrow,
          0.5,
          { x: "-2.5vh", opacity: 0 },
          { x: "0", opacity: 1 },
          "start"
        );

      // Create the Scene and trigger when visible
      let scene = new ScrollMagic.Scene({
        reverse: true,
        triggerElement: elem,
      })
        .setTween(tl)
        .addTo(controller);

      // Add debug indicators fixed on right side
      //scene.addIndicators({ name: 'section' });
    });

    //_____________________________________________________________
    //animazione mask tramite css
    $(".mask").each(function () {
      let m = $(this);
      //let tl = new TimelineMax();
      //tl.to(e, time, { y: 0, alpha: 1 });

      let scene = new ScrollMagic.Scene({
        reverse: true,
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setTween(m, 1, {
          //backgroundColor: 'green',
          //scale: 1.5,
          //y: 120,
          //opacity: 0,
          css: {
            //top: '110%',
            //fontSize: '10vw',
            right: "100%",
          },
        })
        //.addIndicators({ name: 'blocchi con maschere' })
        .addTo(controller);
    });

    //_____________________________________________________________
    //animazione caroselli immagine tramite gsap
    $(".elementor-widget-image-carousel").each(function () {
      let tl = new TimelineMax();
      let e = $(this);

      tl.fromTo(e, 1, { x: "50px", opacity: 0 }, { x: "0", opacity: 1 });

      let scene = new ScrollMagic.Scene({
        reverse: true,
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setTween(tl)
        //.addIndicators({ name: 'blocchi con maschere' })
        .addTo(controller);
    });

    //_____________________________________________________________
    $(".hero").each(function () {
      let ewp = $(this).find(".elementor-widget-wrap");
      let ebs = $(this).find(".elementor-background-slideshow");
      let headline = $(this).find(".headline.t1");

      let tm = TweenMax.fromTo(
        ewp,
        5,
        { y: "-50px", opacity: 1 },
        { y: "-300px", opacity: 0 }
      );

      let tm2 = TweenMax.fromTo(
        ebs,
        5,
        { y: "-50px", opacity: 1 },
        { y: "-150px", opacity: 0 }
      );

      let scene = new ScrollMagic.Scene({
        reverse: true,
        triggerElement: this,
        triggerHook: 0,
        duration: "100%",
      })
        .setTween(tm)
        .setPin(".hero", { pushFollowers: false })
        //.addIndicators({ name: 'hero' })
        .addTo(controller);
    });

    //_____________________________________________________________
    $(".griglia").each(function () {
      let ep = $(this).find(".elementor-post");
      let ewcta = $(this).find(".elementor-widget-call-to-action");

      let ml = new TimelineMax();
      ml.staggerFromTo(
        ep,
        1.2,
        { opacity: 0 },
        { opacity: 1, stagger: 0.2 }
      ).staggerFromTo(ewcta, 1.2, { opacity: 0 }, { opacity: 1, stagger: 0.2 });

      let scene = new ScrollMagic.Scene({
        reverse: true,
        triggerElement: this,
        triggerHook: 0.5,
      })
        .setTween(ml)
        .addTo(controller);
      // scene.addIndicators({ name: 'griglie' });
    });

    //_____________________________________________________________
    // header
    /*
    var scene = new ScrollMagic.Scene({
      triggerElement: 'body',
      duration: '100%',
      triggerHook: 0,
    })
      .setTween('.wpbf-page-header::before', { height: '200%' })
      //.addIndicators({ name: 'logo' }) // add indicators (requires plugin)
      .addTo(controller);
    */

    //only on mobile
    //_____________________________________________________________
    var smallLogo = new ScrollMagic.Scene({
      triggerElement: "body",
      duration: "100%",
      triggerHook: 0,
    })
      .setTween(".wpbf-logo", { scale: 0.7, top: "-.5em" })

      //.addIndicators({ name: 'logo' }) // add indicators (requires plugin)
      .addTo(controller);

    function sizeAll() {
      var w = window.innerWidth;
      if (w < 1024) {
        smallLogo.enabled(false);
      } else {
        smallLogo.enabled(true);
      }
    }

    $(window).resize(sizeAll);
    sizeAll();
  });
})(jQuery);
